export const isGuest = () => {
  return localStorage.getItem("Startuptoken") === "DEMO_TOKEN";
};

export const isStartupLoggedIn=()=>{
  return localStorage.getItem("startupId")?localStorage.getItem("startupId"):false
}